import { BannerItem, ItemMenu, ItemOutstanding, ItemProduct, Partner, User } from '.';

export const Menu: ItemMenu[] = [
    { title: 'Outstanding', link: 'outstanding' },
    { title: 'Featured Products', link: 'featured-products' },
    { title: 'Partners', link: 'partners' },
    { title: 'Our Team', link: 'team' },
];

export const Outstanding: ItemOutstanding[] = [
    {
        total: 150,
        unit: 'M+',
        title: 'Downloads',
        image: 'assets/images/total_ic_download.png',
    },
    { total: 25, unit: 'M+', title: 'MAU', image: 'assets/images/ic_MAU.png' },
    {
        total: 100,
        unit: '+',
        title: 'Total Apps',
        image: 'assets/images/ic_total app.png',
    },
];

export const BannerItems: BannerItem[] = [
    { image: 'assets/images/banner_app_1.webp', strength: 0.08, x: -30, y: -25, mx: -40, my: -23, z: 10 },
    { image: 'assets/images/banner_app_2.webp', strength: 0.06, x: 22, y: -35, mx: -30, my: 30, z: 5 },
    { image: 'assets/images/banner_app_6.webp', strength: 0.07, x: -45, y: 4, mx: 40, my: -25, z: 12 },
    { image: 'assets/images/banner_app_5.webp', strength: 0.1, x: -20, y: 30, mx: 30, my: 30, z: 8 },
    { image: 'assets/images/banner_app_4.webp', strength: 0.05, x: 24, y: 35, mx: 0, my: -30, z: 6 },
    { image: 'assets/images/banner_app_3.webp', strength: 0.09, x: 42, y: 4, mx: 0, my: 40, z: 4 },
];

export const hotProduct: ItemProduct = {
    title: 'Color Phone',
    total: '1.000.000+',
    image: 'assets/images/product_7.png',
    thumbnail: 'assets/images/thum_product_7.png',
    link: 'https://play.google.com/store/apps/details?id=com.callscreen.colorphone.calltheme.callscreener.callerscreenapp',
};

export const products: ItemProduct[] = [
    {
        title: 'Super VPN: Safe & Secure VPN',
        total: '10.000.000+',
        image: 'assets/images/product_9.png',
        thumbnail: 'assets/images/thum_product_9.png',
        link: 'https://play.google.com/store/apps/details?id=com.free.vpn.unlimited.hotpotshield.vpnmaster',
    },
    {
        title: 'PDF Reader',
        total: '10.000.000+',
        image: 'assets/images/product_1.png',
        thumbnail: 'assets/images/thum_product_1.png',
        link: 'https://play.google.com/store/apps/details?id=com.pdfreader.pdfeditor.pdfreadeforandroid.pdfeditorforandroidfree',
    },
    {
        title: 'Color Flash',
        total: '10.000.000+',
        image: 'assets/images/product_10.png',
        thumbnail: 'assets/images/thum_product_10.png',
        link: 'https://play.google.com/store/apps/details?id=com.colorphone.flashalert.ringtones.callscreen.colorflashcall',
    },
    {
        title: 'PDF Scanner',
        total: '10.000.000+',
        image: 'assets/images/product_2.png',
        thumbnail: 'assets/images/thum_product_2.png',
        link: 'https://play.google.com/store/apps/details?id=com.scannerapp.pdfscanner.documentscaner.docscannerappforandroid',
    },
    {
        title: 'All Document',
        total: '5.000.000+',
        image: 'assets/images/product_3.png',
        thumbnail: 'assets/images/thum_product_3.png',
        link: 'https://play.google.com/store/apps/details?id=com.officesuite.fileopener.fileviewer.all.document.reader.word.excel.pptx.pdf',
    },
    {
        title: 'Compass',
        total: '5.000.000+',
        image: 'assets/images/product_4.png',
        thumbnail: 'assets/images/thum_product_4.png',
        link: 'https://play.google.com/store/apps/details?id=com.compass.compassapp.compassfree',
    },
    {
        title: 'Flash Alert',
        total: '5.000.000+',
        image: 'assets/images/product_5.png',
        thumbnail: 'assets/images/thum_product_5.png',
        link: 'https://play.google.com/store/apps/details?id=com.flashlight.torch.light.app.mobileflashlight.flashlightapp.ledflashlight',
    },
    {
        title: 'Layout',
        total: '5.000.000+',
        image: 'assets/images/product_6.png',
        thumbnail: 'assets/images/thum_product_6.png',
        link: 'https://play.google.com/store/apps/details?id=com.volio.layout.photocollage.collagemaker',
    },
];

export const Partners: Partner[] = [
    { title: 'Admob', image: 'assets/images/icon_partners_1.png' },
    { title: 'App Store', image: 'assets/images/icon_partners_5.png' },
    { title: 'AppLovin', image: 'assets/images/icon_partners_8.png' },
    { title: 'AppsFlyer', image: 'assets/images/icon_partners_9.png' },
    { title: 'Google Ads', image: 'assets/images/icon_partners_3.png' },
    { title: 'Google Play', image: 'assets/images/icon_partners_4.png' },
    {
        title: 'Meta Audience Network',
        image: 'assets/images/icon_partners_2.png',
    },
    { title: 'Mintegral', image: 'assets/images/icon_partners_7.png' },

    { title: 'Tiktok', image: 'assets/images/icon_partners_10.png' },
    { title: 'Unity', image: 'assets/images/icon_partners_6.png' },
];

export const Users: User[] = [
    { name: 'VinhNT', role: 'Monet Leader', image: 'assets/images/team_vinhnt_v2.webp' },
    { name: 'HienDX', role: 'Tech Leader', image: 'assets/images/team_hiendx_v2.webp' },
    { name: 'ThoPA', role: 'UX/UI Leader', image: 'assets/images/team_thopa_v2.webp' },
    { name: 'ThuyNT', role: 'UA Leader', image: 'assets/images/team_thuynt_v2.webp' },
    { name: 'HuongCT', role: 'ASO Leader', image: 'assets/images/team_huongct_v2.webp' },
    { name: 'NamDP', role: 'Android Developer', image: 'assets/images/team_namdp_v2.webp' },
    { name: 'NhiemVH', role: 'Ad Ops Specialist', image: 'assets/images/team_nhiemvh_v2.webp' },
    { name: 'DuyLX', role: 'UX/UI Designer', image: 'assets/images/team_duylx_v2.webp' },
];
